/**
 * Work Bright Gateway API
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

// import { ImageDto } from '../../generated-api';
import { apiBaseUrl } from '../../generated-api/api-base-url';

@Injectable({
  providedIn: 'root',
})
export class FilesCustomService {

  constructor(
    protected api: CoreApiClientService) {
  }

  // /**
  //  * [Authorize] type: http
  //  */
  // public filesGet$(ids?: Array<number>): Observable<Array<FileDto>> {
  //   return this.api.get(`${apiBaseUrl()}/files`, { ids });
  // }
  // /**
  //  * [Authorize] type: http
  //  */
  // public filesPost$(files: Array<any>, type: string): Observable<Array<FileDto>> {
  //   const formData = new FormData();
  //   // tslint:disable-next-line:forin
  //   for (const index in files) {
  //     formData.append('files', files[index]);
  //   }
  //   formData.append('type', type);
  //   return this.api.post(`${apiBaseUrl()}/files`, formData, undefined);
  //   // return this.api.multipartPost(`${apiBaseUrl()}/files`, { files, category }, undefined);
  // }

  // public imagesPost$(files: Array<any>): Observable<Array<ImageDto>> {
  //   console.log('files', files);
  //   const formData = new FormData();
  //   for (const index in files) {
  //     formData.append('files', files[index])
  //   }
  //   console.log('formData', formData);
  //   return this.api.post(`${apiBaseUrl()}/images`, formData, undefined);
  // }

  // public imagesAsyncPost$(files: Array<any>): Promise<Array<ImageDto>> {
  //   return new Promise<ImageDto[]>((resolve, reject) => {
  //     console.log('files', files);
  //     const formData = new FormData();
  //     for (const index in files) {
  //       formData.append('files', files[index])
  //     }
  //     console.log('formData', formData);
  //     this.api.post(`${apiBaseUrl()}/images`, formData, undefined).subscribe(
  //       {
  //         next: resolve,
  //         error: reject
  //       }
  //     )


  // console.log('files', files);
  // const formData = new FormData();
  // for (const index in files) {
  //   formData.append('files', files[index])
  // }
  // console.log('formData', formData);
  // return this.api.post(`${apiBaseUrl()}/images`, formData, undefined);
  // })
  // }

}
